import * as types from './mutation-types';
export default {
  /**
   * ERROR HANDLING
   */
  [types.ERROR_MESSAGE](state,payload){
    this.$app.$toasted.show(payload.message, { 
      theme: "bubble", 
      position: "top-right", 
      duration : 5000
   });
  },

  /**
   * LOADERS
   */
  [types.START_LOADER](state){
    state.actionLoader=true;
  },[types.FINISH_LOADER](state){
    state.actionLoader=false;
  },
  [types.UPDATE_MODULES] (state, payload) {
    state.modules = payload
  },
  [types.CURRENT_USER] (state, payload) {  
    state.currentUser = payload;
  },
  [types.SET_NOTIFICATIONS](state,payload){
    state.notifications=payload;
  },
  [types.UPDATE_PACKDATA](state,payload){
    state.packdata=payload;
  },
  [types.UPDATE_PACKLIST](state,payload){
    state.packcollection=payload;
  },
  /**
   * AREA
   */
  [types.ADDNEW_AREA](state,payload){
    state.areas.push(payload)
  },
  [types.ADDNEW_DATAGROUP](state,payload){
    state.datagroups.push(payload)
  },  
  [types.UPDATE_AREAS] (state, payload) {
    state.areas = payload;
  },
  [types.UPDATE_DATAGROUPS] (state, payload) {
    state.datagroups = payload;
  },
  [types.CURRENT_BUSINESS] (state, payload) {
    state.business = payload;
    state.businessId=payload.id;
  },
  [types.CURRENT_BUSINESSLIST] (state, payload) {
    state.allBusiness = payload;
  },
  [types.SELECT_AREA](state,payload){
    state.actualArea=payload;
  },
  [types.SELECT_DATAGROUP](state,payload){
    state.actualDatagroup=payload;
  },
  [types.SELECT_BOARD](state,payload){
    state.board=payload;
  },
  [types.ALLBOARDS_BUSINESS](state,payload){
    state.allBoards=payload;
  },
  [types.ALLPIPELINES_BUSINESS](state,payload){
    state.allPipelines=payload;
  },
  //BRANCHS
  [types.GET_BRANCHS](state,payload){
    state.allBranchs=payload;
  },
  [types.UPDATE_ACTUALBRANCHS](state,payload){
    state.allBranchs.push(payload);
  },
  [types.SET_ACTUALBRANCH](state,payload){
    state.actualBranchId=payload.id;
    state.actualBranch=payload;
  },
  //TEAM
  [types.GET_TEAMS](state,payload){
    state.allTeams=payload;
  },
  [types.UPDATE_ACTUALTEAMS](state,payload){
    state.allTeams.push(payload);
  },

  [types.SELECTED_TEAM](state,payload){
    state.actualTeam=payload
  },
  //BUSINESS MEMEBERS
  [types.BUSINESS_MEMBERS](state,payload){
    state.members=payload;
  },
  [types.ADDBUSINESS_MEMBERS](state,payload){
    state.members.push(payload);
  },
  //BUSINESS SCHEMES
  [types.UPDATE_SCHEMES](state,payload){
    state.schemeList=payload
  },
  [types.UPDATE_ACTUALSCHEME](state,payload){
    state.actualScheme=payload
  },
  //
  [types.UPDATE_INTEGRATIONS](state,payload){
    state.integrations=payload
  },
  [types.UPDATE_INTEGRATIONSHUB](state,payload){
    state.integrationsHub=payload
  },
  [types.UPDATE_SHARELINKDETAIL](state,payload){
    state.sharelinkdetail=payload;
  },
  [types.UPDATE_TARGETLIST](state,payload){
    state.targets.push(payload)
  },
  [types.SET_TARGETLIST](state,payload){
    state.targets=payload;
  },
  [types.SET_COLORTAGS](state,payload){
    state.colortags=payload;
  },
  [types.UPDATE_COLORTAGS](state,payload){
    state.colortags.push(payload)
  },
  [types.SELECTPCARD](state,payload){
    state.currentProxycard=payload;
  },
  //FLUJO MODAL
  [types.SET_ACTUALPIPELINE](state,payload){
    state.actualPipeline=payload;
  },
  [types.OPEN_COLUMNMODAL](state,payload){
      state.activeColumnModal=true;
  }
}
